import { LitElement, html, css } from 'lit'

class DropdownContainer extends LitElement {
  static styles = css`
    :host {
      display: inline-flex;
      position: relative;
    }

    .trigger {
      appearance: none;
      border: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      
      transition: all ease-in-out 150ms;
      
      cursor: pointer;
  
      background:var(--trigger-background);
    }

    .trigger:hover {
      background:var(--trigger-background-hover, var(--trigger-background));
    }

    .trigger:focus-visible {
     
    }

    :host([open]) .trigger {
      background:var(--trigger-background-open, var(--trigger-background-hover));
      background-size: 100% 100% !important;
    }

    .dropdown {
      display: none;
      position: absolute;
      left:0;
      //right:0;
      top:calc(100% + .25rem);
      z-index:100;

    }

    :host([open]) .dropdown {
      display: block;
    }

    .dropdown__inner {

    }

    :host([open]) .dropdown__inner {

    }

    .dropdown__label {

    }

    @media (max-width: 430px) {

    }
  `
  static properties = {
    open: { type: Boolean, reflect: true },
    summary: { type: String },
    selected: { type: String, reflect: true },
    selectedSummary: { type: String, reflect: true },
    type: { type: String },
  }
  constructor() {
    super()
    this.open = false
    this.id = Math.random().toString(36).substring(2, 9)
    this.addEventListener('dropdown-select', this.handleOptionSelect)
    this.addEventListener('keydown', this.handleUpKey.bind(this))
    this.addEventListener('keydown', this.handleDownKey.bind(this))
    this.addEventListener('keydown', this.handleEscKey.bind(this))
  }
  firstUpdated() {
    this.shadowRoot
      .querySelector('.dropdown')
      .addEventListener('click', (e) => {
        e.stopPropagation()
      })
    this.trigger = this.shadowRoot.querySelector('.trigger')
    this.dropdown = this.shadowRoot.querySelector('.dropdown')
    this.options = this.querySelectorAll('dropdown-option')
    this.buttons = this.querySelectorAll('dropdown-option button')
    this.buttons.forEach((option) => {
      option.setAttribute('aria-selected', this.selected === option.value ? 'true' : 'false')
      option.setAttribute('id', `${this.id}_${option.value}`)
    })
    this.selectedSummary = this.querySelector(`dropdown-option:has(button[aria-selected="true"])`)?.description
    this.dropdown.setAttribute('inert', 'inert')
  }
  updated(changedProperties) {
    if (changedProperties.has('open')) {
      if (this.open) {
        document.addEventListener('click', this.handleClickOutside.bind(this))
        this.querySelector(
          'dropdown-option button[aria-selected="true"]'
        )?.focus()
        this.dropdown.removeAttribute('inert')
      } else {
        if(changedProperties.get('open') !== undefined) {
          //Don't on first update
          this.trigger.focus()
          document.removeEventListener(
            'click',
            this.handleClickOutside.bind(this)
          )
        }
      }
    }
  }
  handleEscKey(e) {
    if (e.key === 'Escape') {
      this.open = false
      this.trigger.focus()
    }
  }
  handleUpKey(e) {
    if (e.key === 'ArrowUp') {
      e.preventDefault()
      const current = this.querySelector('dropdown-option button:focus')
      if (
        current &&
        current.closest('dropdown-option').previousElementSibling
      ) {
        current
          .closest('dropdown-option')
          .previousElementSibling.querySelector('button')
          .focus()
      } else {
        this.buttons[this.options.length - 1].focus()
      }
    }
  }
  handleDownKey(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      const current = this.querySelector('dropdown-option button:focus')
      if (current && current.closest('dropdown-option').nextElementSibling) {
        current
          .closest('dropdown-option')
          .nextElementSibling.querySelector('button')
          .focus()
      } else {
        this.querySelector('dropdown-option button').focus()
      }
    }
  }

  handleClickOutside(e) {
    if (e.target === this) return
    this.open = false
  }

  handleOptionSelect(e) {
    this.selected = e.detail.value
    this.selectedSummary = e.detail.summary
    this.setAttribute('aria-activedescendant', e.detail.value)
    this.querySelectorAll('dropdown-option button').forEach((option) => {
      if (option.value === e.detail.value) {
        option.setAttribute('aria-selected', 'true')
      } else {
        option.setAttribute('aria-selected', 'false')
      }
    })
    if (this.type === 'single') {
      this.open = false
    }
  }
  render() {
    return html`
      <button
        class="trigger"
        aria-expanded="${this.open}"
        aria-controls="${this.id}"
        part="trigger"
        @click=${() => (this.open = !this.open)}
      >
        ${this.selectedSummary || this.summary}
        <toggle-icon ?open=${this.open}></toggle-icon>
      </button>

      <div
        class="dropdown"
        part="dropdown"
        aria-labeledby="${this.id}_label"
        role="listbox"
        id="${this.id}"
      >
        <div class="dropdown__inner">
          <slot></slot>
        </div>
      </div>
    `
  }
}
customElements.define('dropdown-container', DropdownContainer)

// class DropdownOption extends LitElement {
//   static styles = css`
//     :host {
//       display: block;
//     }
//   `
//   static properties = {
//     open: { type: Boolean, reflect: true },
//     description: { type: String },
//     value: { type: String },
//   }
//   constructor() {
//     super()
//     this.addEventListener('click', this.handleOptionSelect)
//     this.querySelector('button').setAttribute('role', 'option')
//   }
//   handleOptionSelect(e) {
//     this.dispatchEvent(
//       new CustomEvent('dropdown-select', {
//         detail: { value: this.value, summary: this.description },
//         bubbles: true,
//         composed: true,
//       })
//     )
//   }
//   render() {
//     return html`<slot></slot>`
//   }
// }
// customElements.define('dropdown-option', DropdownOption)
